import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appContext", "flexDirection", "offeringId", "ratingKey", "reviewType", "hiddenSections"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { FavoriteIcon } from 'foundations-assets/icons/components/FavoriteIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { RatingDistribution } from 'trellis-ecosystem';
import { useReviews } from '../../hooks/useReviews';
import ReviewFilters from '../../records/ReviewFilters';
import Rating from '../Rating';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemReviewsStats(_ref) {
  let {
      appContext = 'public',
      flexDirection,
      offeringId,
      ratingKey,
      reviewType,
      hiddenSections = []
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    reviewStats,
    reviewStatsFetchStatus
  } = useReviews({
    appContext,
    reviewFilters: new ReviewFilters({
      entityId: offeringId,
      reviewTypes: [reviewType]
    }),
    offeringId,
    reviewType
  });
  const overallRatingAvg = reviewStats.getAxisAverage(ratingKey);
  const totalReviews = reviewStats.get('count');
  const typography = flexDirection === 'column' ? 'heading-1000' : 'heading-800';
  const orderedRatings = Object.entries(reviewStats.getOverallPercentages() || {}).reverse().map(([key, value]) => ({
    key,
    value
  }));
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    flexDirection: flexDirection
  }, rest, {
    children: /*#__PURE__*/_jsxs(LoadingWrapper, {
      requestStatus: reviewStatsFetchStatus,
      children: [!hiddenSections.includes('average') && /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.averageRating"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: typography,
          children: /*#__PURE__*/_jsx(FormattedNumber, {
            stripInsignificantZeros: false,
            value: overallRatingAvg || 0,
            precision: 1
          })
        }), /*#__PURE__*/_jsx(Rating, {
          rating: overallRatingAvg || 0,
          direction: "column",
          label: /*#__PURE__*/_jsx(Text, {
            color: "text-core-subtle",
            typography: "detail-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-reviews.stats.reviewCount",
              options: {
                count: reviewStats.get('count')
              }
            })
          }),
          labelSize: "medium"
        }), flexDirection === 'column' && /*#__PURE__*/_jsx(HR, {})]
      }), !hiddenSections.includes('total') && /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.totalReviews"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: typography,
          children: /*#__PURE__*/_jsx(FormattedNumber, {
            stripInsignificantZeros: false,
            value: totalReviews,
            precision: 0
          })
        }), /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "detail-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-ui-reviews.stats.reviewTotal",
            options: {
              count: reviewStats.get('count')
            }
          })
        }), flexDirection === 'column' && /*#__PURE__*/_jsx(HR, {})]
      }), !hiddenSections.includes('distribution') && orderedRatings.length > 0 && /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(RatingDistribution, {
          icon: FavoriteIcon,
          iconProps: {
            color: 'fill-accent-yellow-default'
          },
          ratings: orderedRatings
        }), flexDirection === 'column' && /*#__PURE__*/_jsx(HR, {})]
      })]
    })
  }));
}